import React from "react";
import './chatbotInput.css';
import {cn} from "../../../../../utils/utils";

const ChatbotInput = ({sendMessage, isLoading, touched, placeholder}) => {

    const [input, setInput] = React.useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (input.trim() === "" || isLoading) return;
        sendMessage(input);
        setInput("");
    }

    return (<div className={cn("chatbot-input", {"chatbot-input-start": !touched})}>
        <input
            className="chatbot-input__input"
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={placeholder ?? "Preguntale algo a Firulais..."}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
        />
        <button
            className="chatbot-input__submit-btn"
            disabled={!input.trim() || isLoading}
            onClick={handleSubmit}>
            <i className="fa-solid fa-paper-plane"></i>
        </button>
    </div>)
}

export default ChatbotInput;
